module.exports = __webpack_public_path__ + "8381cf956ae92e170df5a73acd17097e.fbx";